class TollFreeNumbers extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML = `
    <style>
      /* .scrollable_npanxx {     
        height: 200px;
        overflow: scroll;
        scroll-behavior: auto;
      } */
    </style>
    <!--label>Toll Free Numbers</label-->
    <div class="row">
      <div class="col-sm-9 no-gutters" id="local-num-input">
        <div class="radio">
          <label><input type="radio" name="toll_free_npa" value="888" checked>888-XXX-XXXX</label>
        </div>
        <div class="radio">
          <label><input type="radio" name="toll_free_npa" value="833">833-XXX-XXXX</label>
        </div>
        <div class="radio">
          <label><input type="radio" name="toll_free_npa" value="844">844-XXX-XXXX</label>
        </div>
        <div class="radio">
          <label><input type="radio" name="toll_free_npa" value="855">855-XXX-XXXX</label>
        </div>
        <div class="radio">
          <label><input type="radio" name="toll_free_npa" value="866">866-XXX-XXXX</label>
        </div>
        <div class="radio">
          <label><input type="radio" name="toll_free_npa" value="877">877-XXX-XXXX</label>
        </div>
      </div>
    </div>
    `;

    this.init();
  }
 
  init() {
    $('.campaign_toll_free').on('switchChange.bootstrapSwitch', function(event, state) {
      !state ? this.classList.add("hidden") : this.classList.remove("hidden")
    }.bind(this));

    this.querySelectorAll("input[name=toll_free_npa]").forEach(function(element) {
      element.addEventListener("change", function() {
        this.validateSelections();
      }.bind(this));
    }.bind(this));

    this.validateSelections();
  }

  isValid() {
    if(!this.valid) this.querySelector("input").classList.add("error");
    return this.valid;
  }
  
  reset() {
    this.valid = false;
    this.value = [];
  }

  validateSelections() {
    let selected = this.querySelector("input[name=toll_free_npa]:checked");
    this.valid = selected != null;
    if(selected != null) {
      this.value = selected.value;
    }


  }

}

customElements.define("toll-free-numbers", TollFreeNumbers)